import { molecule } from "bunshi"
import { getApiClient } from "."
import { ApplicationEnvironmentMolecule } from "../env/store"

const BffBaseUrlMolecule = molecule(
  (mol) => mol(ApplicationEnvironmentMolecule).bffBaseUrl,
)

export const BffApiClientMolecule = molecule((mol) => {
  const bffBaseUrl = mol(BffBaseUrlMolecule)

  return getApiClient(bffBaseUrl)
})
